<template>
  <div class="node-studio-download">
    <el-card shadow="never" class="guide-card">
      <div class="guide-title">
        <i class="el-icon-view" />
        <span>使用可视化前需安装 Node Studio</span>
      </div>
      <p class="guide-desc">
        本机未检测到 Node Studio 运行。请下载安装包并按下方步骤安装，装好后回到数据列表，重新点击「可视化」即可正常使用。
      </p>

      <!-- 系统要求 + 下载 -->
      <div class="section">
        <div class="section-title">1. 下载安装包</div>
        <el-alert
          title="当前支持 Ubuntu 20.04 / 22.04 LTS（x86_64），Windows 版开发中"
          type="info"
          :closable="false"
          show-icon
          class="os-alert"
        />
        <div class="download-row">
          <el-button
            type="primary"
            size="medium"
            icon="el-icon-download"
            :loading="downloading"
            @click="handleDownload"
          >
            下载 node-studio_{{ info.version }}_amd64.deb
          </el-button>
          <span v-if="info.version" class="version-tag">版本 {{ info.version }}</span>
        </div>
      </div>

      <!-- 安装步骤 -->
      <div class="section">
        <div class="section-title">2. 安装</div>
        <p class="step-desc">打开终端，进入下载目录，执行以下命令（可点击复制）：</p>
        <div class="command-box" @click="copyCommand">
          <code>{{ installCommand }}</code>
          <el-button
            type="text"
            size="small"
            :class="['copy-btn', { copied }]"
            @click.stop="copyCommand"
          >
            {{ copied ? '已复制 ✓' : '复制' }}
          </el-button>
        </div>
      </div>

      <!-- 装好后 -->
      <div class="section">
        <div class="section-title">3. 完成</div>
        <p class="step-desc">安装完成后，回到数据列表，重新点击「可视化」即可打开 Node Studio。</p>
      </div>

      <div class="back-row">
        <el-button icon="el-icon-back" @click="$router.push('/data')">返回数据列表</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import { fetchNodeStudioDownloadInfo } from '../api/data';

export default {
  name: 'NodeStudioDownload',
  data() {
    return {
      info: { version: '', downloadUrl: '', docUrl: '' },
      downloading: false,
      copied: false,
    };
  },
  computed: {
    installCommand() {
      return `sudo dpkg -i node-studio_${this.info.version}_amd64.deb`;
    },
  },
  async created() {
    try {
      const res = await fetchNodeStudioDownloadInfo();
      this.info = res.data;
    } catch {
      // 拿不到配置时下载按钮不可用；错误提示已由拦截器处理
    }
  },
  methods: {
    async handleDownload() {
      if (!this.info.downloadUrl) return;
      this.downloading = true;
      try {
        // 同源 nginx 静态托管，直接跳转下载
        window.location.href = this.info.downloadUrl;
      } finally {
        setTimeout(() => {
          this.downloading = false;
        }, 1000);
      }
    },
    async copyCommand() {
      const cmd = this.installCommand;
      try {
        await navigator.clipboard.writeText(cmd);
      } catch {
        // 剪贴板 API 不可用时降级为文本框复制
        const ta = document.createElement('textarea');
        ta.value = cmd;
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
      }
      this.copied = true;
      setTimeout(() => {
        this.copied = false;
      }, 2000);
    },
  },
};
</script>

<style scoped>
.node-studio-download {
  /* 宽度与数据列表页一致（全宽铺满主内容区） */
}

/* 卡片样式对齐数据列表页（filter-card/table-card） */
.guide-card {
  border-radius: 8px;
  border: 1px solid #e8eaed;
}

.guide-title {
  display: flex;
  align-items: center;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 12px;
}

.guide-title i {
  margin-right: 8px;
  color: #409eff;
}

.guide-desc {
  color: #606266;
  line-height: 1.7;
  margin-bottom: 8px;
}

.section {
  margin: 24px 0;
}

.section-title {
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 10px;
}

.os-alert {
  margin-bottom: 14px;
}

.download-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.version-tag {
  color: #909399;
  font-size: 13px;
}

.step-desc {
  color: #606266;
  font-size: 14px;
}

.command-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f4f4f5;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  padding: 10px 14px;
  cursor: pointer;
}

.command-box code {
  font-family: 'Courier New', monospace;
  font-size: 14px;
  user-select: all;
}

.copy-btn {
  color: #409eff;
}

.copy-btn.copied {
  color: #67c23a;
}

.back-row {
  margin-top: 32px;
}
</style>
